import { render, staticRenderFns } from "./PatentBulletinReviewList.vue?vue&type=template&id=7268d462&"
import script from "./PatentBulletinReviewList.vue?vue&type=script&lang=js&"
export * from "./PatentBulletinReviewList.vue?vue&type=script&lang=js&"
import style0 from "./PatentBulletinReviewList.vue?vue&type=style&index=0&id=7268d462&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports